import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 1F1BE05B-E67A-4646-A8B3-08423BD58673
 * name arrow-up-down-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-down-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowUpDownBoldOutlineIcon = createSvgIcon(<><path d="M16,10H22L12,0L2,10H8V14H2L12,24L22,14H16V10M14,16H17L12,21L7,16H10V8H7L12,3L17,8H14V16Z" /></>, 'ArrowUpDownBoldOutlineIcon');
export default ArrowUpDownBoldOutlineIcon